import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'
import date from 'vue-date-filter'
import { LicenseManager } from 'ag-grid-enterprise/main'
import VueAuthImage from './components/authImage/authImage'
import VueAuthImageSvg from './components/authImage/authImageSvg'
import VueEvents from 'vue-events'
import 'ag-grid/dist/styles/ag-grid.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.min.css'
import 'vuetify/dist/vuetify.min.css'

import 'styles/ag-grid-variable-balham.scss'
import 'styles/ag-grid-kiwa.scss'

import { messages } from 'vuex-store/modules/translations/menu_items'

import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import http from './http/index'

import ReportPage from './views/reports/reportComponents/ReportPage'
import './assets/report/reportStyle.css'

LicenseManager.setLicenseKey('Streamline_IT_Solutions_MultiApp_1Devs22_May_2018__MTUyNjk0MzYwMDAwMA==cfa4ddf39b945ecaa380a19e9a963e20')

Vue.router = router

Vue.use(date)
Vue.use(VueEvents)
Vue.use(Vuetify)

Vue.use(VueLocalStorage, {
  name: 'localStorage'
})

Vue.use(VueAxios, http.axios)

Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    },
    response: function (res) {
      // Get Token from request header, because token doesn't expire
      return res.config.headers.Authorization ? res.config.headers.Authorization.slice(7) : null
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  token: [
    { request: 'token', response: 'token', authType: 'bearer', foundIn: 'response' }
  ],
  kiwaData: { url: process.env.API_URL + '/user/me', method: 'GET', redirect: '/' },
  kiwaOauth2Data: {
    redirect: () => process.env.SITE_URL + '/login',
    url: process.env.DATASTORE_URL + '/oauth/authorize',
    clientId: process.env.CLIENT_ID,
    data: {},
    scope: ' ',
    response_type: 'token'
  },
  logoutData: {
    url: process.env.DATASTORE_URL + '/logout', method: 'GET', redirect: '/login', makeRequest: true
  },
  refreshData: {
    enabled: false
  }
})

Vue.use(NProgress)

Vue.use(VueI18n)

Vue.use(VueAuthImage)
Vue.use(VueAuthImageSvg)

// Enable devtools
Vue.config.devtools = true

sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

const { state } = store

const i18n = new VueI18n({
  locale: 'nl',
  fallbackLocale: 'en',
  messages
})

i18n.silentTranslationWarn = true

router.beforeEach((route, redirect, next) => {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false)
  }
  next()
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.component('report-page', ReportPage)

Vue.config.errorHandler = (err, vm, info) => {
  console.error(err)
}

const app = new Vue({
  i18n,
  router,
  store,
  nprogress,
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#005DA1',
          secondary: '#00609c',
          accent: '#D10E1C',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  }),
  ...App
})

export { app, router, store }
